/* eslint-disable no-unused-vars */
import application from 'application/application';

const controller = 'ModulePeopleController';

application.controller(controller, [
	'$scope',
	'$http',
	'$sce',
	'$element',
	'$timeout',
	'$rootScope',
	($scope, $http, $sce, $element, $timeout, $rootScope) => {
		$scope.loadingPageIframe = true;

		const isLocalhost = window.location.origin.includes('localhost');
		const base = isLocalhost
			? 'https://dev-plataforma.advise.com.br'
			: window.location.origin;
		const currentUrlString = base + '/v2-pessoas/';

		const versionUrl =
			currentUrlString +
			'assets/version.json?v=' +
			encodeURIComponent(Date.now());

		function setIframeSrc(v) {
			const src = currentUrlString + '?v=' + encodeURIComponent(v);

			$scope.iframeSrc = $sce.trustAsResourceUrl(src);
		}

		let detachIframeListeners = null;

		function attachIframeClickListener(iframe) {
			if (detachIframeListeners) detachIframeListeners();

			const win = iframe.contentWindow;
			const doc = iframe.contentDocument || (win && win.document);

			if (!doc) return;

			const handler = () => {
				$scope.$applyAsync(() => {
					if ($rootScope.exitSubMenu == true) $rootScope.handleExitSubMenu();
				});
			};

			doc.addEventListener('mousedown', handler, true);
			doc.addEventListener('touchstart', handler, true);

			detachIframeListeners = () => {
				doc.removeEventListener('mousedown', handler, true);
				doc.removeEventListener('touchstart', handler, true);
			};
		}

		// handler chamado pelo onload do iframe
		$scope.onIframeLoad = () => {
			$scope.loadingPageIframe = false;
			$scope.$applyAsync();

			const iframe = $element[0].querySelector('#module-people');

			if (!iframe) return;

			try {
				attachIframeClickListener(iframe);
			} catch (e) {
				// Se cair aqui, quase sempre é porque NÃO é same-origin (ex.: localhost -> dev-plataforma)
				console.warn(
					e
				);
			}
		};

		$timeout(() => {
			const iframe = $element[0].querySelector('#module-people');

			if (iframe) {
				iframe.addEventListener('load', $scope.onIframeLoad, { once: true });
			}
		});

		if (isLocalhost) {
			setIframeSrc(Date.now());
		} else {
			$http
				.get(versionUrl, { cache: false })
				.then(resp => {
					const d = (resp && resp.data) || {};

					setIframeSrc(d.version || Date.now());
				})
				.catch(() => {
					setIframeSrc(Date.now());
				});
		}
	}
]);

export default controller;
